import React, { useEffect } from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { toast } from 'react-toastify';
import TopNav from '../../components/TopNav';
import Footer from '../../components/Footer';
import { useTitle } from '../../hooks/useTitle';

const Unsubscribe = () => {
  const { subscType } = useParams<{ subscType: string }>();
  const [ searchParams ] = useSearchParams();
  const navigate = useNavigate();
  const { get } = useApi();

  useTitle('Ton Bébé | 配信停止');

  useEffect(() => {
    const email = searchParams.get('email');

    if (!email) {
      toast.error('メールアドレスが指定されていません。');
      navigate('/');
      return;
    }

    if (!subscType) {
      toast.error('配信停止の種類が指定されていません。');
      navigate('/');
      return;
    }

    get({
      endpoint: `unsubscribe/${ subscType }`,
      params: { email, api_mode: 'true' },
      skipAuth: true,
      onSuccess: (data) => {
        toast.success('通知を停止しました。');
        navigate('/');
      },
      onError: (err) => {
        toast.error('通知の停止に失敗しました。');
        navigate('/');
      },
    });
  }, [subscType, searchParams, get, navigate]);

  return (
    <>
      <header>
        <TopNav />
      </header>
      <main className="sub">
        <section className="unsubscribe">
          <div className="unsubscribe-content">
            <p>配信停止処理を実行しています...</p>
          </div>
        </section>
      </main>
      <Footer />
      <style>{ `
        .unsubscribe {
          text-align: center;
          padding: 80px 20px;
          min-height: calc(100vh - 400px);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .unsubscribe-content {
          max-width: 600px;
          margin: 0 auto;
        }

        .unsubscribe-content p {
          font-size: 16px;
          color: #666;
          line-height: 1.6;
        }

        @media (max-width: 768px) {
          .unsubscribe {
            padding: 60px 20px;
          }

          .unsubscribe-content p {
            font-size: 14px;
          }
        }
      ` }</style>
    </>
  );
};

export default Unsubscribe;
